import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routers from "./router/index";
import ViewportProvider from "./components/viewportContext";
import { useEffect } from "react";

import { isMobileOrSmallScreen } from "./utils/deviceDetect";

function App() {
  useEffect(() => {
    const handleResize = () => {
      // 检查当前路径是否为 /native-login
      if (
        window.location.pathname === "/native-login" ||
        window.location.pathname === "/native-logout"
      ) {
        return; // 如果是 /native-login 路径，跳过重定向检查
      }

      if (isMobileOrSmallScreen()) {
        window.location.href = "https://www.pinai.io/";
      }
    };

    // 初始检查
    handleResize();

    // 监听窗口大小变化
    window.addEventListener("resize", handleResize);

    // 清理监听器
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <ViewportProvider>
      <div
        className="w-screen h-screen overflow-y-auto"
        style={{ backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
      >
        {/* <header className="App-header">
        If the user is not authenticated, show a login button
        If the user is authenticated, show the user object and a logout button

      </header> */}
        <ToastCustom />
        <Routers></Routers>
      </div>
    </ViewportProvider>
  );
}
const ToastCustom = () => {
  return (
    <ToastContainer
      position="bottom-center"
      autoClose={2000}
      hideProgressBar
      closeOnClick
      pauseOnHover
      draggable
      toastStyle={{
        backgroundColor: "#333",
        color: "white",
        width: "300px",
        padding: "8px",
        borderRadius: "8px",
        textAlign: "center",
        fontSize: "15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      style={{
        position: "fixed",
        bottom: "100px",
        width: "300px",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    />
  );
};
export default App;
